import React from "react";
/* eslint-disable */
import {
    Box, TableBody, TableCell, TableHead, TableRow, Table,
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
    state = {
        page: 0,
        rowsPerPage: 5
    };

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
    };

    render() {
        const gtnWiseSummaryDetails = this.props.gtnWiseSummaryDetails;
        const totalValue = this.props.totalValue;

        return (
            <div style={{ padding: '10px' }}>
                <h3><center><u>GTN Wise Summary Report</u></center></h3>
                <div>&nbsp;</div>
                <div>&nbsp;</div>
                <Box minWidth={1050}>
                    <Table aria-label="caption table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ border: "1px solid black" }} align="left" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Order Date</TableCell>
                                <TableCell sx={{ border: "1px solid black" }} align="left" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>FCC</TableCell>
                                {/* <TableCell sx={{ border: "1px solid black" }} style={{ verticalAlign: 'top', textAlign: 'center', justifyContent: 'center' }}>Order Number</TableCell> */}
                                <TableCell sx={{ border: "1px solid black" }} style={{ verticalAlign: 'top', textAlign: 'center', justifyContent: 'center' }}>GTN Number</TableCell>
                                <TableCell sx={{ border: "1px solid black" }} style={{ verticalAlign: 'top', textAlign: 'center', justifyContent: 'center' }}>GTN Sequence No</TableCell>
                                <TableCell sx={{ border: "1px solid black" }} style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>Lorry Number</TableCell>
                                <TableCell sx={{ border: "1px solid black" }} style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>Sku Code</TableCell>
                                <TableCell sx={{ border: "1px solid black" }} style={{ verticalAlign: 'top', textAlign: 'left', justifyContent: 'center' }}>Description</TableCell>
                                {/* <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>GRN Price</TableCell> */}
                                <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>GRN WAC Price</TableCell>
                                <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Quantity</TableCell>
                                <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Value (Rs)</TableCell>
                                
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(() => {
                                const groupedData = [];
                                gtnWiseSummaryDetails.forEach((item) => {
                                    const lastGroup = groupedData[groupedData.length - 1];
                                    if (
                                        lastGroup &&
                                        lastGroup.gtnNumber === item.gtnNumber &&
                                        lastGroup.lorryNumber === item.lorryNumber
                                    ) {
                                        lastGroup.rows.push(item);
                                    } else {
                                        groupedData.push({
                                            gtnNumber: item.gtnNumber,
                                            gtnNo: item.gtnNo,
                                            lorryNumber: item.lorryNumber,
                                            rows: [item],
                                        });
                                    }
                                });
                                return groupedData.map((group, groupIndex) => (
                                    <React.Fragment key={groupIndex}>
                                        {group.rows.map((row, rowIndex) => (
                                            <TableRow key={rowIndex}>
                                                <TableCell sx={{ border: "1px solid black" }} align="left">
                                                    {moment(row.orderDate).format("YYYY-MM-DD")}
                                                </TableCell>
                                                <TableCell sx={{ border: "1px solid black" }} align="left">{row.factoryName}</TableCell>
                                                {/* <TableCell sx={{ border: "1px solid black" }} align="right">{row.ordernumber}</TableCell> */}
                                                {rowIndex === 0 && (
                                                    <TableCell
                                                        sx={{ border: "1px solid black" }}
                                                        align="center"
                                                        rowSpan={group.rows.length}
                                                    >
                                                        {group.gtnNumber}
                                                    </TableCell>
                                                )}
                                                {rowIndex === 0 && (
                                                    <TableCell
                                                        sx={{ border: "1px solid black" }}
                                                        align="center"
                                                        rowSpan={group.rows.length}
                                                    >
                                                        {group.gtnNo == null ? '-' : group.gtnNo}
                                                    </TableCell>
                                                )}
                                                {rowIndex === 0 && (
                                                    <TableCell
                                                        sx={{ border: "1px solid black" }}
                                                        align="center"
                                                        rowSpan={group.rows.length}
                                                    >
                                                        {group.lorryNumber}
                                                    </TableCell>
                                                )}
                                                <TableCell sx={{ border: "1px solid black" }} align="right">{row.skuCode}</TableCell>
                                                <TableCell sx={{ border: "1px solid black" }} align="left">{row.skuDescription}</TableCell>
                                                {/* <TableCell sx={{ border: "1px solid black" }} align="right">
                                                    {row.grnPrice == 0 || null
                                                        ? "-"
                                                        : parseFloat(row.grnPrice).toLocaleString("en-US", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}
                                                </TableCell> */}
                                                <TableCell sx={{ border: "1px solid black" }} align="right">
                                                    {row.quantity == 0 || row.value == 0 || row.quantity == null || row.value == null
                                                        ? "-"
                                                        : parseFloat(row.value / row.quantity).toLocaleString("en-US", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}
                                                </TableCell>
                                                <TableCell sx={{ border: "1px solid black" }} align="right">{row.quantity?.toFixed(2)}</TableCell>
                                                <TableCell sx={{ border: "1px solid black" }} align="right">
                                                    {row.value == 0 || row.value == null
                                                        ? "-"
                                                        : parseFloat(((row.value/row.quantity).toFixed(2))*row.quantity).toLocaleString("en-US", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}
                                                </TableCell>
                                                
                                            </TableRow>
                                        ))}
                                    </React.Fragment>
                                ));
                            })()}
                            <TableRow>
                                <TableCell
                                    sx={{ border: "1px solid black" }}
                                    style={{
                                        fontWeight: 'bold',
                                        verticalAlign: 'top',
                                        textAlign: 'left',
                                    }}
                                    colSpan={9}
                                >
                                    Total Value (Rs)
                                </TableCell>
                                <TableCell sx={{ border: "1px solid black" }} style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                    {totalValue === 0 ? '-' : parseFloat(totalValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </TableCell>
                                {/* <TableCell sx={{ border: "1px solid black" }} >
                                </TableCell> */}
                            </TableRow>
                        </TableBody>
                    </Table>
                </Box>
            </div>
        );
    }
}
